import { ExclusiveComponentsConstants } from '../exclusiveComponents/ExclusiveComponentsConstants';
import { v4 as uuid } from 'uuid';
export class ExclusiveComponentsService {
    static $inject = ['PipelineBuilderStateService', '$translate'];
    constructor(PipelineBuilderStateService, $translate) {
        'ngInject';
        this.PipelineBuilderStateService = PipelineBuilderStateService;
        this.$translate = $translate;
    }
    async createBlipChatCopyAndPaste() {
        return this.PipelineBuilderStateService.createBlipChatCopyAndPaste(await this.$translate('builder.exclusiveComponents.components.channels.blipChat.copyAndPaste.title'));
    }
    getBlipChatCopyAndPaste(state, onUpdate) {
        const oldContentActions = JSON.parse(state.$contentActions.find(action => action.action.settings.type === ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE).action.settings.rawContent);
        const blipChatCopyAndPaste = {
            document: {
                id: uuid(),
                type: ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE,
                content: {
                    body: oldContentActions.body,
                    button: {
                        text: oldContentActions.button.text,
                        value: oldContentActions.button.value,
                    },
                    footer: oldContentActions.footer,
                    header: oldContentActions.header,
                },
            },
            'on-save': onUpdate,
            'on-deleted': (_) => ({}),
            'on-metadata-edit': (_) => ({}),
            'on-open-link': () => ({}),
            editable: true,
            deletable: false,
            position: 'left',
            editing: false,
        };
        return blipChatCopyAndPaste;
    }
}
ExclusiveComponentsService.$inject = ['PipelineBuilderStateService', '$translate'];
